/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import MeshSpiralMaterial from './materials/MeshSpiralMaterial.jsx'
import { useFrame } from '@react-three/fiber'

export default function HighlightMiddle(props) 
{
    const self = useRef()

  const { nodes, materials } = useGLTF('./models/spiral-middle.glb')

  useFrame(( state, delta ) =>
    {
        const time = state.clock.elapsedTime * 3.4
        const scale = 0.2 * Math.sin( time ) + 0.8

        // self.current.rotation.y += delta * 6
        self.current.scale.set( scale, scale, scale )
    })

  return (
    <group {...props} dispose={null}>
        <mesh
            ref={ self }
            geometry={nodes.Cylinder.geometry}
        >
            <MeshSpiralMaterial
                frontColor='#022028'
                backColor='#3DF5FF'
                intensity={ 2.7 }
                powerOffset={ 12 }
                colorBoth={ true }
            />
        </mesh>
    </group>
  )
}

useGLTF.preload('./models/spiral-middle.glb')